import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Constants from '../../constants';
import { useNavigate } from '../../react-router';
import { PlanId } from '../../utils/paywall';
import {
  formatEntitlementHint,
  formatStaffUsageLine,
  resolveSeatPlanId,
} from '../../utils/staffSeats';

export default function StaffSeatsSummary({
  teamUsed,
  planId,
  compact,
}: {
  teamUsed: number;
  planId?: PlanId;
  compact?: boolean;
}): JSX.Element | null {
  const navigate = useNavigate();
  const plan = planId ?? resolveSeatPlanId();
  if (!Constants.oppText) {
    return null;
  }

  return (
    <View style={[styles.box, compact && styles.boxCompact]}>
      <Text style={styles.usage}>{formatStaffUsageLine(plan, teamUsed)}</Text>
      {!compact ? (
        <Text style={styles.hint}>{formatEntitlementHint(plan)}</Text>
      ) : null}
      {!compact ? (
        <Text style={styles.link} onPress={() => navigate('/plans')}>Purchase additional seats</Text>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  box: {
    backgroundColor: '#FFF',
    borderRadius: 10,
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginBottom: 24,
    borderWidth: 1,
    borderColor: Constants.colors.secondaryLight,
  },
  boxCompact: {
    marginBottom: 16,
    paddingVertical: 10,
  },
  usage: {
    fontFamily: 'GothamBold',
    fontSize: 14,
    color: Constants.colors.blue,
    marginBottom: 6,
  },
  hint: {
    fontFamily: 'Gotham',
    fontSize: 12,
    color: Constants.colors.secondary,
    lineHeight: 18,
  },
  link: {
    fontFamily: 'GothamMedium',
    fontSize: 13,
    color: Constants.colors.blue,
    textDecorationLine: 'underline',
    marginTop: 8,
  },
});
